import { css } from '@emotion/react'
import { Cell, Grid, InfoLabel, VFlow } from 'bold-ui'
import { HLabel } from 'components/HLabel'
import { EvolucaoAvaliacao } from 'graphql/types.generated'
import { formatDate } from 'util/date/formatDate'
import StatusSquare from 'view/atendimentos/detail/historico/components/StatusSquare'
import { EvolucaoProblema, situacaoProblemaRecord } from 'view/atendimentos/detail/soap/aside/types/ProblemaModel'

import { HistoricoAvaliacaoProblemasCondicoesCiapCidTableContent } from './HistoricoAvaliacaoProblemasCondicoesCiapCidTableContent'

const getCiapCidEvolucaoProblema = (evolucaoProblema: EvolucaoProblema) => {
  const { problema, possuiCiap, possuiCid, possuiCid11 } = evolucaoProblema

  return {
    ciap: possuiCiap ? problema?.ciap : undefined,
    cid10: possuiCid ? problema?.cid10 : undefined,
    cid11: possuiCid11 ? problema?.cid11 : undefined,
  }
}

interface HistoricoAvaliacaoProblemasCondicoesTableContentProps {
  evolucaoAvaliacao: EvolucaoAvaliacao
  evolucaoProblema: ReadonlyArray<EvolucaoProblema>
}

export default function HistoricoAvaliacaoProblemasCondicoesTableContent(
  props: HistoricoAvaliacaoProblemasCondicoesTableContentProps
) {
  const { evolucaoAvaliacao, evolucaoProblema } = props

  return (
    <VFlow>
      {evolucaoProblema?.map((evolucao) => {
        const situacaoProblema = evolucao.situacao ? situacaoProblemaRecord[evolucao.situacao] : undefined
        const { background, descricao } = situacaoProblema ?? {}

        return (
          <Grid gap={2} key={evolucao.id}>
            <Cell size={6}>
              <HistoricoAvaliacaoProblemasCondicoesCiapCidTableContent {...getCiapCidEvolucaoProblema(evolucao)} />
            </Cell>

            <Cell size={6}>
              <InfoLabel title='Lista de problemas/condições'>
                {background && descricao && <StatusSquare color={background} description={descricao} />}
              </InfoLabel>
            </Cell>

            <Cell size={6} style={styles.observacaoCell}>
              {evolucao.observacao && <HLabel title='Observações:'>{evolucao.observacao}</HLabel>}
            </Cell>

            {(evolucao.dataFim || evolucao.dataInicio) && (
              <Cell size={6}>
                <HLabel title='Data de início:'>{formatDate(evolucao.dataInicio)}</HLabel>
                <HLabel title='Data de fim:'>{formatDate(evolucao.dataFim)}</HLabel>
              </Cell>
            )}
          </Grid>
        )
      })}

      {evolucaoAvaliacao.ciapsCids
        ?.filter((ciapCid) => !ciapCid.isCiapCidNaListaDeProblemas)
        .map((ciapCid) => (
          <Grid gap={2} key={ciapCid.id}>
            <Cell size={6}>
              <HistoricoAvaliacaoProblemasCondicoesCiapCidTableContent
                ciap={ciapCid.ciap}
                cid10={ciapCid.cid10}
                cid11={ciapCid.cid11}
              />
            </Cell>

            <Cell size={6}>
              <InfoLabel title='Lista de problemas/condições'>Não incluído</InfoLabel>
            </Cell>

            {ciapCid.nota && (
              <Cell size={12}>
                <HLabel title='Observações:'>{ciapCid.nota}</HLabel>
              </Cell>
            )}
          </Grid>
        ))}
    </VFlow>
  )
}

const styles = {
  observacaoCell: css`
    align-self: end;
  `,
}
